import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25.9,6.1A14,14,0,1,0,30,16,13.94,13.94,0,0,0,25.9,6.1ZM24.49,24.49A12,12,0,1,1,28,16,12,12,0,0,1,24.49,24.49Z"/><path d="M12.2,12.21,21,14.51l-3.78,1.66-.71.31-.31.71L14.51,21,12.2,12.21M11.49,10a1.55,1.55,0,0,0-1.06.44,1.52,1.52,0,0,0-.38,1.42l2.9,11A1.49,1.49,0,0,0,14.29,24h.1a1.49,1.49,0,0,0,1.38-.93L18,18l5.07-2.23A1.49,1.49,0,0,0,22.9,13l-11-2.9a1.57,1.57,0,0,0-.37-.05Z"/>';
export var CompassOutlineSVG = function CompassOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CompassOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CompassOutlineSVG);